import AuthApis from '@/api/auth'
import StorageService from '@/services/storage-service'
import NotificationsApi from '@/api/notifications'

export default {
  namespaced: true,
  state: {
    user: null,
    token: null,
    impersonate: false,
    authenticated: false,
    fcmTokenSent: typeof sessionStorage !== 'undefined' && !!sessionStorage.getItem('bya3_fcm_token_sent'),
    notifications: [],
    notificationsTotal: 0,
    admin: false,
    referral: false,
    referrals: [],
    referralsFetched: false,
    modelType: 'fb',
    loader: false,
    totalStorage: 100,
    availableStorage: 100,
    showInstagram: false,
    androidAppUrl: '',
  },
  getters: {
    isAuthenticated: (state: any) => !!state.user,
    isAdmin: (state: any) => state.admin ?? false,
    modelType: (state: any) => state.modelType ?? 'fb',
    isReferral: (state: any) => state.referral ?? false,
    isClient: (state: any, getters: any) => !getters.isReferral && !getters.isAdmin,
    isFacebook: (state: any, getters: any) => getters.modelType === 'fb',
    isStore: (state: any, getters: any) => getters.modelType === 'store',
    isInstagram: (state: any, getters: any) => getters.modelType === 'instagram',
    user: (state: any) => state.user ?? {},
    token: (state: any) => state.token ?? '',
    showInstagram: (state: any) => state.showInstagram ?? false,
    impersonate: (state: any) => state.impersonate,
    notifications: (state: any) => state.notifications,
    referrals: (state: any) => state.referrals,
    referralsFetched: (state: any) => state.referralsFetched,
    notificationsTotal: (state: any) => state.notificationsTotal,
    loader: (state: any) => state.loader,
    totalStorage: (state: any) => state.totalStorage,
    availableStorage: (state: any) => state.availableStorage,
    currentModelId: (state: any, getters: any, rootState: any, rootGetters: any) => (getters.isFacebook ? rootGetters['pages/currentPageId'] : rootGetters['instagram/currentAccountId']),
    fcmTokenSent: (state: any) => state.fcmTokenSent ?? false,
    androidAppUrl: (state: any) => state.androidAppUrl ?? '',
  },
  mutations: {
    SET_USER(state: any, user: unknown) {
      state.user = user
    },
    SET_LOADER(state: any, loader: boolean) {
      state.loader = loader
    },
    SET_MODEL_TYPE(state: any, type: string) {
      state.modelType = type
      StorageService.setItem('bya3_account_type', type)
    },
    SET_AUTHENTICATED(state: any, value: boolean) {
      state.authenticated = value
    },
    SET_TOKEN(state: any, token: string) {
      state.token = token
      StorageService.setItem('bya3_api_token', token)
    },
    UPDATE_USER(state: any, user: any) {
      state.user = {
        ...state.user,
        ...user,
      }
    },
    SET_IMPERSONATE(state: any, impersonate: boolean) {
      state.impersonate = impersonate
    },
    SET_STORAGE(state: any, storage: any) {
      state.availableStorage = storage?.availableStorage ?? 100
      state.totalStorage = storage?.totalStorage ?? 100
    },
    SET_ROLES(state: any, payload: any) {
      state.admin = payload?.admin ?? false
      state.referral = payload?.referral ?? false
    },
    SET_NOTIFICATIONS(state: any, notifications: any) {
      state.notifications = notifications
    },
    SET_REFERRALS(state: any, referrals: any) {
      state.referrals = referrals
      state.referralsFetched = true
    },
    SET_NOTIFICATIONS_TOTAL(state: any, total: number) {
      state.notificationsTotal = total
    },
    SET_SHOW_INSTAGRAM(state: any, status: any) {
      state.showInstagram = status
    },
    SET_FCM_TOKEN_SENT(state: any, value: boolean) {
      state.fcmTokenSent = value
      if (typeof sessionStorage !== 'undefined') {
        if (value) {
          sessionStorage.setItem('bya3_fcm_token_sent', '1')
        } else {
          sessionStorage.removeItem('bya3_fcm_token_sent')
        }
      }
    },
    SET_ANDROID_APP_URL(state: any, url: string) {
      state.androidAppUrl = url || ''
    },
  },
  actions: {
    async LOGIN(context: any, { username, password, impersonate = false }: any) {
      let success = false
      await AuthApis.login({ username, password }).then((data: any) => {
        context.dispatch('PREPARE_USER', { ...data, oneTime: impersonate })
        success = true
      }).catch(() => {
        context.commit('SET_USER', null)
        context.commit('SET_ROLES', null)
        context.commit('SET_AUTHENTICATED', false)
      })
      return success
    },
    async CHECK_TOKEN(context: any, { impersonate = false }: any) {
      const response = (await AuthApis.user()).data
      await context.dispatch('PREPARE_USER', { ...response, oneTime: impersonate })
      if (impersonate) {
        context.commit('SET_IMPERSONATE', true)
      }
      return response?.user
    },
    async LOGOUT(context: any) {
      if (context.state.impersonate) {
        context.commit('SET_IMPERSONATE', false)
      }
      context.commit('SET_USER', {})
      context.commit('SET_AUTHENTICATED', false)
      context.commit('SET_FCM_TOKEN_SENT', false)
      StorageService.removeItem('bya3_api_token')
    },
    async PREPARE_USER(context: any, {
      access_token, user, pages, admin, referral, insta_accounts, storage, stores, show_instagram, android_app_url,
    }: any) {
      if (!user) throw new Error('Set user failed')
      context.commit('SET_USER', user)
      context.commit('SET_STORAGE', storage)
      context.commit('SET_SHOW_INSTAGRAM', show_instagram)
      context.commit('SET_ANDROID_APP_URL', android_app_url || '')
      context.commit('SET_TOKEN', access_token)
      context.commit('SET_ROLES', { admin, referral })
      context.commit('pages/SET_PAGES', pages ?? [], { root: true })
      context.commit('instagram/SET_INSTA_ACCOUNTS', insta_accounts ?? [], { root: true })
      context.commit('shop/SET_STORES', stores ?? [], { root: true })

      context.commit('SET_MODEL_TYPE', StorageService.getItem('bya3_account_type', 'fb'))
    },
    async FETCH_NOTIFICATIONS(context: any) {
      await NotificationsApi.notifications().then(res => {
        context.commit('SET_NOTIFICATIONS', res.notifications)
        context.commit('SET_NOTIFICATIONS_TOTAL', res.total)
      }).catch(() => {
      })
    },
    async Mark_NOTIFICATION_READ(context: any, id: number) {
      await NotificationsApi.markAsRead(id).then(res => {
        context.commit('SET_NOTIFICATIONS', res.notifications)
        context.commit('SET_NOTIFICATIONS_TOTAL', res.total)
      }).catch(() => {
      })
    },

    async FETCH_REFERRALS(context: any) {
      if (context.state.referralsFetched) return
      await AuthApis.referralList().then(res => {
        context.commit('SET_REFERRALS', res)
      }).catch(() => {
      })
    },
  },
}
